import { render, staticRenderFns } from "./ProductSpecificationComponent.vue?vue&type=template&id=5b917266&scoped=true&"
import script from "./ProductSpecificationComponent.vue?vue&type=script&lang=js&"
export * from "./ProductSpecificationComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProductSpecificationComponent.vue?vue&type=style&index=0&id=5b917266&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b917266",
  null
  
)

export default component.exports